export default __webpack_public_path__ + "static/media/notification-sound.aa94b1c8.mp3";